import LogoMini from "../../../components/icons/LogoMini";
import PlayTriangle from "../../../components/icons/PlayTriangle";
import "../general.scss";
import "./index.scss";
import Membership from "../../../assets/img/SolutionsIcons/AgilysysMembership.svg";
import { Header } from "../../../components/Header";

const MembershipsFPage = () => {
    return(
        <div className="page splash membershipsFPage">
            <div className="page-title"><img src={Membership} alt="" /></div>
            <Header />
            <div className="text-blocks">
                <div className="std-text">
                Control your programs by defining the membership types
you need. Whether you manage memberships for
individuals, families, groups, corporate accounts or all of
these, you define the parameters for each.{'\n\n'}
                </div>
                <div className="std-text">
                The Membership Portal allows easy online registrations for
new members and gives members the ability to check their
balances and redeem points via gift cards, eCash, loyalty,
etc.
                </div>
            </div>
            {/*<div className="play-video" onClick={()=>setShowVideo(true)}>
                <PlayTriangle />
                Play Video
            </div>*/}
            <img className="img-1" src={"https://storage.googleapis.com/popshap-kiosks-dev.appspot.com/agilysys/FeaturedSolutions/Membership1.png"} alt="" />
            <img className="img-2" src={"https://storage.googleapis.com/popshap-kiosks-dev.appspot.com/agilysys/FeaturedSolutions/Membership2.png"} alt="" />
        </div>
    )
}

export default MembershipsFPage;